import { render, staticRenderFns } from "./LiveChallengeBanner.vue?vue&type=template&id=25c57e20&scoped=true&"
import script from "./LiveChallengeBanner.vue?vue&type=script&lang=js&"
export * from "./LiveChallengeBanner.vue?vue&type=script&lang=js&"
import style0 from "./LiveChallengeBanner.vue?vue&type=style&index=0&id=25c57e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c57e20",
  null
  
)

export default component.exports